import React, { useState, useEffect, useRef } from 'react';
import Header from '../home/components/Header.tsx';
import { qryCopilotValueApi, getCopilotValueByTaskIdApi } from '@/api/copilot';
import TabNavigation from '@/components/TabNavigation.tsx';
import ProductRecommend from './components/tabs/ProductRecommendTab.tsx';
import ProductComparisonTab from './components/tabs/ProductComparisonTab.tsx';
import ProductInterpretationTab from './components/tabs/ProductInterpretationTab.tsx';
import MarketInterpretationTab from './components/tabs/MarketInterpretationTab.tsx';
import CustomerNeedsRecognition from './components/CustomerNeedsRecognition';
import { useNavigate } from 'react-router-dom';
import { EXTERNAL_USER_ID } from '@/config/env';
import customerAvatar from '@/imgs/customer-avatar.png';
import { toast } from 'sonner';
import { usePollingApi } from '@/hooks/usePollingApi';

// 类型定义
interface TotalData {
  issues: Array<{
    title: string;
    desc: string;
  }>;
}

// 修复：用 forwardRef 包裹，明确 props 和 ref 类型（避免 any）
const DiagnosisPage = React.forwardRef<TotalData | null, {}>(() => {
  let currentTaskId = '';
  const navigate = useNavigate();
  const hasFetched = useRef(false);
  const [loading11, setLoading11] = useState(true);
  const [loading8, setLoading8] = useState(true);
  const [loading9, setLoading9] = useState(true);
  const [loading10, setLoading10] = useState(true);

  const [totalData8, setTotalData8] = useState<any>({});
  const [totalData9, setTotalData9] = useState<any>({});
  const [totalData10, setTotalData10] = useState<any>({});
  const [totalData11, setTotalData11] = useState<any>({});

  // 市场解读 agent
  const {
    data: pollingData11,
    startPolling: startPolling11,
    stopPolling: stopPolling11
  } = usePollingApi(
    // API 调用函数
    () =>
      getCopilotValueByTaskIdApi({
        externalUserId: EXTERNAL_USER_ID,
        reqType: 11,
        taskId: currentTaskId
      }),
    // 检查条件：status === 'false' 时继续轮询，'true' 时停止
    response => {
      console.log('轮询响应:', response);
      return response?.status === 'false';
    },
    {
      interval: 1000,
      onSuccess: data => {
        console.log('轮询成功，获取到数据:', data);
        setTotalData11(data);
        setLoading11(false);

        // toast.success('数据获取成功');
      },
      onError: error => {
        console.error('轮询失败:', error);
        toast.error(error || '数据获取失败');
        setLoading11(false);
        setTotalData11({});
      }
    }
  );

  // 产品推荐 agent
  const {
    data: pollingData8,
    startPolling: startPolling8,
    stopPolling: stopPolling8
  } = usePollingApi(
    // API 调用函数
    () =>
      getCopilotValueByTaskIdApi({
        externalUserId: EXTERNAL_USER_ID,
        reqType: 8,
        taskId: currentTaskId
      }),
    // 检查条件：status === 'false' 时继续轮询，'true' 时停止
    response => {
      console.log('轮询响应:', response);
      return response?.status === 'false';
    },
    {
      interval: 1000,
      onSuccess: data => {
        console.log('轮询成功，获取到数据:', data);
        // setTotalData8(data);
        // toast.success('数据获取成功');
        setLoading8(false);
        setTotalData8(data);
      },
      onError: error => {
        console.error('轮询失败:', error);
        toast.error(error || '数据获取失败');
        setLoading8(false);
        setTotalData8({});
      }
    }
  );

  // 产品对比 agent
  const {
    data: pollingData9,
    startPolling: startPolling9,
    stopPolling: stopPolling9
  } = usePollingApi(
    // API 调用函数
    () =>
      getCopilotValueByTaskIdApi({
        externalUserId: EXTERNAL_USER_ID,
        reqType: 9,
        taskId: currentTaskId
      }),
    // 检查条件：status === 'false' 时继续轮询，'true' 时停止
    response => {
      console.log('轮询响应:', response);
      return response?.status === 'false';
    },
    {
      interval: 1000,
      onSuccess: data => {
        console.log('轮询成功，获取到数据:', data);
        // setTotalData8(data);
        // toast.success('数据获取成功');
        setLoading9(false);
        setTotalData9(data);
      },
      onError: error => {
        console.error('轮询失败:', error);
        toast.error(error || '数据获取失败');
        setLoading9(false);
        setTotalData9({});
      }
    }
  );

  // 产品解读 agent
  const {
    data: pollingData10,
    startPolling: startPolling10,
    stopPolling: stopPolling10
  } = usePollingApi(
    // API 调用函数
    () =>
      getCopilotValueByTaskIdApi({
        externalUserId: EXTERNAL_USER_ID,
        reqType: 10,
        taskId: currentTaskId
      }),
    // 检查条件：status === 'false' 时继续轮询，'true' 时停止
    response => {
      console.log('轮询响应:', response);
      return response?.status === 'false';
    },
    {
      interval: 1000,
      onSuccess: data => {
        console.log('轮询成功，获取到数据:', data);
        // setTotalData8(data);
        // toast.success('数据获取成功');
        setLoading10(false);
        setTotalData10(data);
      },
      onError: error => {
        console.error('轮询失败:', error);
        toast.error(error || '数据获取失败');
        setLoading10(false);
        setTotalData10({});
      }
    }
  );

  // 获取初始任务ID并开始轮询
  const fetchCopilotData = async () => {
    try {
      const response = await qryCopilotValueApi({
        externalUserId: EXTERNAL_USER_ID,
        reqType: 0
      });
      console.log('获取到任务ID:', response);
      if (response) {
        currentTaskId = response;
        // 开始轮询
        startPolling8();
        startPolling9();
        startPolling10();
        startPolling11();
      }
    } catch (error) {
      console.error('获取Copilot数据失败:', error);
      toast.error('获取任务ID失败');
    }
  };

  // 组件挂载时获取数据
  useEffect(() => {
    console.log('HomePage 组件挂载');
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchCopilotData();
    }
  }, []);

  // 当轮询数据更新时，更新 totalData
  useEffect(() => {
    if (pollingData11) {
      setTotalData11(pollingData11);
    }
  }, [pollingData11]);

  // 组件卸载时停止轮询
  useEffect(() => {
    return () => {
      stopPolling11();
    };
  }, [stopPolling11]);

  const tabs = [
    { label: '产品推荐', value: 'productRecommend' },
    { label: '产品对比', value: 'productComparison' },
    { label: '产品解读', value: 'productInterpretation' },
    { label: '市场解读', value: 'marketInterpretation' }
  ];
  const [activeTab, setActiveTab] = useState<string>('productRecommend');

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="relative mx-auto flex h-screen flex-col overflow-hidden bg-gradient-to-b from-blue-50 via-blue-50 to-purple-100">
      <Header goBack={goBack}>
        <div className="text-lg font-semibold leading-none tracking-tight">AI投顾洞察</div>
      </Header>
      <div className="px-4">
        <div className="flex items-center gap-1">
          {/* 头像容器 */}
          <div className="h-6 w-6 overflow-hidden">
            <img src={customerAvatar} alt="客户头像" className="h-full w-full object-cover" />
          </div>
          {/* 标题 */}
          <span className="text-base font-semibold leading-6 text-[#1F1F1F]">客户需求识别</span>
        </div>

        {/* 客户需求识别组件 */}
        <CustomerNeedsRecognition />

        <div className="mt-3 rounded-lg bg-white p-3">
          <TabNavigation
            tabs={tabs}
            activeTab={activeTab}
            onUpdateActiveTab={setActiveTab}
            clsWrapper="px-0"
          />
          <div className="relative h-[500px] space-y-3 overflow-hidden pb-4">
            {activeTab === 'productRecommend' && (
              <ProductRecommend totalData={totalData8} loading={loading8} />
            )}
            {activeTab === 'productComparison' && (
              <ProductComparisonTab totalData={totalData9} loading={loading9} />
            )}
            {activeTab === 'productInterpretation' && (
              <ProductInterpretationTab totalData={totalData10} loading={loading10} />
            )}
            {activeTab === 'marketInterpretation' && (
              <MarketInterpretationTab totalData={totalData11} loading={loading11} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

DiagnosisPage.displayName = 'DiagnosisPage';
export default DiagnosisPage;
